export const scaleValue = (
  value: number,
  size: "small" | "medium" | "large"
) => {
  let scaledValue = value;

  switch (size) {
    case "medium":
      scaledValue *= 1.2;
      break;
    case "large":
      scaledValue *= 1.4;
      break;
    default:
  }

  if (window.innerWidth >= 2160) {
    scaledValue *= 2;
  }

  return scaledValue;
};
